import { render } from "./DeleteDogDialog.vue?vue&type=template&id=08b772cc"
import script from "./DeleteDogDialog.vue?vue&type=script&lang=js"
export * from "./DeleteDogDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__